export enum INPUT_APPEARANCE {
  DEFAULT = 'default',
  MONO = 'mono',
}
